import { ComponentDetailsSectionVisibility } from './component-details.types';

export const DEFAULT_COMPONENT_DETAILS_SECTION_VISIBILITY: ComponentDetailsSectionVisibility = {
  marketing: true,
  configuration: true,
  game: true,
  targeting: true,
  constraints: true,
  limits: true,
  engagement: true,
  schedule: true,
  links: true,
  fulfilment: true,
};
